export const assessmentData = [
  {
    id: "org",
    title: "Responsabilidad y organización",
    questions: [
      { id: "org_1", text: "¿Existe una persona responsable de las decisiones de seguridad de la red?" },
      { id: "org_2", text: "¿Está claro quién aprueba nuevos usuarios y accesos?" },
      { id: "org_3", text: "¿Se revisan periódicamente los riesgos de seguridad del negocio?" },
      { id: "org_4", text: "¿Existe un proceso para documentar cambios importantes en la red?" },
      { id: "org_5", text: "¿La dirección o gerencia participa en decisiones de seguridad?" }
    ]
  },
  {
    id: "inv",
    title: "Inventario de activos",
    questions: [
      { id: "inv_1", text: "¿Existe una lista actualizada de computadoras, laptops, servidores y dispositivos móviles?" },
      { id: "inv_2", text: "¿Existe una lista de usuarios con acceso a sistemas importantes?" },
      { id: "inv_3", text: "¿Se sabe qué aplicaciones en la nube usa el negocio?" },
      { id: "inv_4", text: "¿Está identificada la información más sensible del negocio?" },
      { id: "inv_5", text: "¿Se conoce qué proveedores externos tienen acceso a sistemas o datos?" }
    ]
  },
  {
    id: "acc",
    title: "Control de accesos",
    questions: [
      { id: "acc_1", text: "¿La autenticación multifactor está activada en el correo y sistemas críticos?" },
      { id: "acc_2", text: "¿Se eliminan cuentas de exempleados o usuarios inactivos?" },
      { id: "acc_3", text: "¿Se revisa quién tiene permisos de administrador?" },
      { id: "acc_4", text: "¿Se usan contraseñas únicas para cada sistema?" },
      { id: "acc_5", text: "¿Se evita compartir contraseñas entre empleados?" },
      { id: "acc_6", text: "¿El acceso de proveedores externos está limitado y controlado?" }
    ]
  },
  {
    id: "red",
    title: "Protección de red",
    questions: [
      { id: "red_1", text: "¿El firewall está configurado y revisado periódicamente?" },
      { id: "red_2", text: "¿La red Wi-Fi de invitados está separada de la red interna?" },
      { id: "red_3", text: "¿Los equipos reciben actualizaciones de seguridad regularmente?" },
      { id: "red_4", text: "¿Todos los equipos tienen antivirus o protección de endpoints?" },
      { id: "red_5", text: "¿El acceso remoto se realiza mediante herramientas seguras?" },
      { id: "red_6", text: "¿Los routers y firewalls se mantienen actualizados?" }
    ]
  },
  {
    id: "det",
    title: "Detección de señales de peligro",
    questions: [
      { id: "det_1", text: "¿Alguien revisa alertas de seguridad, antivirus o firewall?" },
      { id: "det_2", text: "¿Se monitorean intentos fallidos de inicio de sesión?" },
      { id: "det_3", text: "¿Existen alertas para accesos desde ubicaciones o dispositivos inusuales?" },
      { id: "det_4", text: "¿Los empleados saben cómo reportar correos sospechosos?" },
      { id: "det_5", text: "¿Se investigan comportamientos extraños en equipos o archivos?" }
    ]
  },
  {
    id: "cap",
    title: "Capacitación del equipo",
    questions: [
      { id: "cap_1", text: "¿El equipo ha recibido capacitación básica sobre phishing?" },
      { id: "cap_2", text: "¿Los empleados saben qué hacer antes de abrir enlaces o archivos sospechosos?" },
      { id: "cap_3", text: "¿Existe un canal claro para reportar correos o actividad sospechosa?" },
      { id: "cap_4", text: "¿La empresa evita culpar a empleados que reportan errores de seguridad?" },
      { id: "cap_5", text: "¿Se envían recordatorios periódicos sobre amenazas comunes?" }
    ]
  },
  {
    id: "res",
    title: "Respuesta a incidentes",
    questions: [
      { id: "res_1", text: "¿Existe una lista de contactos para emergencias de seguridad?" },
      { id: "res_2", text: "¿El equipo sabe qué hacer si un dispositivo parece comprometido?" },
      { id: "res_3", text: "¿Existe un plan básico para contener un incidente?" },
      { id: "res_4", text: "¿Se documentan los incidentes de seguridad?" },
      { id: "res_5", text: "¿Se revisan logs o registros cuando ocurre un problema?" }
    ]
  },
  {
    id: "rec",
    title: "Respaldo y recuperación",
    questions: [
      { id: "rec_1", text: "¿Existen respaldos automáticos de información crítica?" },
      { id: "rec_2", text: "¿Los respaldos se prueban periódicamente?" },
      { id: "rec_3", text: "¿Existe un plan para restaurar archivos o sistemas importantes?" },
      { id: "rec_4", text: "¿La empresa sabe cómo operar si la red principal no está disponible?" },
      { id: "rec_5", text: "¿Existe un plan básico de comunicación durante una interrupción?" }
    ]
  },
  {
    id: "evi",
    title: "Documentación y evidencia",
    questions: [
      { id: "evi_1", text: "¿Existen políticas básicas de seguridad por escrito?" },
      { id: "evi_2", text: "¿Se guardan capturas, reportes o registros como evidencia de controles?" },
      { id: "evi_3", text: "¿Se documentan revisiones de acceso?" },
      { id: "evi_4", text: "¿Se guardan reportes de respaldo o pruebas de restauración?" },
      { id: "evi_5", text: "¿Existe una carpeta o sistema centralizado para organizar evidencia?" },
      { id: "evi_6", text: "¿Se mantienen registros de cambios importantes en sistemas o red?" }
    ]
  },
  {
    id: "pro",
    title: "Proveedor de TI",
    questions: [
      { id: "pro_1", text: "¿Tu proveedor de TI puede explicar qué controles de seguridad están activos?" },
      { id: "pro_2", text: "¿Tu proveedor entrega evidencia o reportes de controles aplicados?" },
      { id: "pro_3", text: "¿Está claro qué acceso tiene el proveedor a tus sistemas?" },
      { id: "pro_4", text: "¿Existe un proceso para revisar o retirar accesos del proveedor?" },
      { id: "pro_5", text: "¿Sabes qué pasaría si tienes un incidente fuera de horario laboral?" },
      { id: "pro_6", text: "¿Sabes qué sucede con tus datos si terminas el contrato con tu proveedor?" }
    ]
  }
];

export const scoreOptions = [
  { label: "Sí", value: 2 },
  { label: "Parcialmente", value: 1 },
  { label: "No", value: 0 },
  { label: "No sé", value: 0 }
];